import { cn } from "@newxsystems/shared";
import { SproutCardLink } from "../../../../modules/content/components/SproutCardLink/SproutCardLink";
import { SproutCommonContent } from "../../../../modules/content/components/SproutCommonContent/SproutCommonContent";
import { SproutRichText } from "../../../../modules/content/components/SproutRichText/SproutRichText";
import { SproutSection } from "../../../../modules/content/components/SproutSection/SproutSection";
import type { ITextContentGridBlockProps } from "./TextContentGridBlock.props";

const columns = {
  1: "grid-cols-1",
  2: "grid-cols-1 sm:grid-cols-2",
  3: "grid-cols-1 sm:grid-cols-2 md:grid-cols-3",
  4: "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4",
} as const;
const spans = {
  1: "col-span-1",
  2: "sm:col-span-2",
  3: "sm:col-span-2 md:col-span-3",
  4: "sm:col-span-2 md:col-span-3 lg:col-span-4",
} as const;

export const TextContentGridBlock = ({
  alignment,
  anchorId,
  buttons,
  columnCount,
  description,
  eyebrow,
  heading,
  items,
  parentClass,
  spacing,
}: ITextContentGridBlockProps) => {
  if (!items?.length) return null;

  return (
    <SproutSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-10 md:gap-14">
        <SproutCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        <div className={cn("grid gap-5", columns[columnCount || 3])}>
          {items.map((item, index) => (
            <SproutCardLink
              className={cn(
                "sprout-paper-lift relative min-h-64 overflow-hidden p-7 pt-12 after:absolute after:left-7 after:top-0 after:h-6 after:w-16 after:rounded-b-lg",
                index % 3 === 0 && "-rotate-[0.4deg] bg-cloud after:bg-coral",
                index % 3 === 1 && "rotate-[0.5deg] bg-whiteboard after:bg-sunflower",
                index % 3 === 2 && "-rotate-[0.25deg] bg-sunflower/25 after:bg-sky",
                spans[item.columnSpan || 1],
              )}
              key={index}
              link={item.cardLink}
            >
              <h3 className="max-w-[18ch] font-sprout-display text-3xl font-bold leading-tight text-foreground">
                {item.heading}
              </h3>
              {item.description ? (
                <SproutRichText
                  className="mt-4 text-base text-basalt md:text-lg"
                  content={item.description}
                />
              ) : null}
            </SproutCardLink>
          ))}
        </div>
      </div>
    </SproutSection>
  );
};

TextContentGridBlock.displayName = "Block::TextContentGridBlock";
